import axiosInstance from ".";

export const getCaseStudies = (term = "") => {
  return axiosInstance.get("/case-studies", {
    params: {
      term: term,
    },
  });
};

export const addCaseStudy = (data) => {
  return axiosInstance.post("/case-studies", data);
};

export const updateCaseStudy = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/case-studies/${id}`, payload);
};

export const deleteCaseStudy = (id) => {
  return axiosInstance.delete(`/case-studies/${id}`);
};

export const getCaseStudyBySlug = (query) => {
  const slug = typeof query === "object" ? query?.queryKey?.[1] : query;
  return axiosInstance.get(`/case-studies/slug/${slug}`);
};
